// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-configurator-zoom product__image__zoom\" data-bind=\"click: $data.ShowOriginalImage.bind($data, $parent.Id, $parent.ImageTableType, $parent.CustomImageKSeq),\r\n              preventBubble: ['click']\"> <i class=\"fa fa-search-plus\"></i> </a>";
// Exports
export default code;